import React from 'react';

const SlackIntegrationDocs: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Slack Integration Docs</h1>
      <div className="space-y-6">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Getting Started</h2>
          <p className="text-gray-700">Learn how to integrate Slack for notifications.</p>
        </div>
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Generating a Slack Webhook</h2>
          <ol className="list-decimal pl-6 text-gray-700">
            <li>
              <strong>Go to Slack API:</strong> Visit{' '}
              <a
                href="https://api.slack.com/messaging/webhooks"
                className="text-blue-600 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Slack's Incoming Webhooks page
              </a>
              .
            </li>
            <li>
              <strong>Create a New Webhook:</strong>
              <ul className="list-disc pl-6">
                <li>Click "Create an app".</li>
                <li>Select "From scratch" and name your app.</li>
                <li>Choose a Slack workspace to install it in.</li>
              </ul>
            </li>
            <li>
              <strong>Enable Incoming Webhooks:</strong>
              <ul className="list-disc pl-6">
                <li>In your app settings, go to "Incoming Webhooks".</li>
                <li>Toggle the feature ON.</li>
              </ul>
            </li>
            <li>
              <strong>Add Webhook to a Channel:</strong>
              <ul className="list-disc pl-6">
                <li>Click "Add New Webhook to Workspace".</li>
                <li>Select a channel where the messages should be posted.</li>
                <li>Click "Allow".</li>
              </ul>
            </li>
            <li>
              <strong>Copy the Webhook URL:</strong>
              <ul className="list-disc pl-6">
                <li>Once the webhook is created, copy the generated URL.</li>
                <li>Use this URL to send JSON payloads to Slack.</li>
              </ul>
            </li>
            <li>
              <strong>Testing:</strong>
              <ul className="list-disc pl-6">
                <li>Head to notification preferences in WeTrackSSL.</li>
                <li>Add the Slack webhook and test to ensure messages can be sent successfully.</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default SlackIntegrationDocs;
